import useActiveBrand from '@/hooks/use-active-brand';
import useCanUseSavedBuilds from '@/hooks/use-can-use-save-builds';
import useStore from '@/state';
import getNormalisedTotal from '@/state/selectors/saved-builds/get-normalised-total';

const useNormalisedSavedBuildsTotal = () => {
	const activeBrand = useActiveBrand();
	const canUseSaveBuildsApi = useCanUseSavedBuilds();

	const normalisedTotal = useStore((state) =>
		getNormalisedTotal(state, activeBrand),
	);

	return canUseSaveBuildsApi ? normalisedTotal : 0;
};

export default useNormalisedSavedBuildsTotal;
